import { ComponentRef, Type, ViewContainerRef } from '@angular/core';
import { DateRangePaneComponent } from '../components/faceted-filter/panes/date-range-pane/date-range-pane.component';
import { FilterPaneComponent } from '../components/faceted-filter/panes/filter-pane/filter-pane.component';
import { HierarchyPaneComponent } from '../components/faceted-filter/panes/hierarchy-pane/hierarchy-pane.component';
import { OperatorPaneComponent } from '../components/faceted-filter/panes/operator-pane/operator-pane.component';
import { IFacetedFilterDataItem, IReplayItem } from '../types';
import { FilterUtils } from './filter.utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PaneComponent = any;
type PaneComponentType = Type<PaneComponent>;

export class PaneComponentFactory {
  private _host: ViewContainerRef;

  public readonly FacetedFilterPaneTypeMap: Record<string, PaneComponentType> = {
    container: FilterPaneComponent,
    dateRangePicker: DateRangePaneComponent,
    operator: OperatorPaneComponent,
    hierarchyFacetContainer: HierarchyPaneComponent,
    commonStringOperator: OperatorPaneComponent,
    percentOperator: OperatorPaneComponent,
    numericOperator: OperatorPaneComponent,
    numberOperator: OperatorPaneComponent,
  };

  constructor(host: ViewContainerRef) {
    this._host = host;
  }

  public loadComponentInstance(item: IFacetedFilterDataItem): ComponentRef<PaneComponent> {
    const componentType = this.getComponentType(item.type);
    const componentInstance = this.getComponentRef(componentType);
    componentInstance.instance.item = item;

    return componentInstance;
  }

  public loadReplayComponentInstance(replayItem: IReplayItem): ComponentRef<PaneComponent> {
    const componentType = this.getComponentType(replayItem.item.type);
    const componentInstance = this.getComponentRef(componentType);
    componentInstance.instance.replayItem = replayItem;
    componentInstance.instance.replayValue = replayItem.value;

    return componentInstance;
  }

  private getComponentType(attribute: string): string {
    return FilterUtils.kebabToCamelCase(attribute);
  }

  private getComponentRef(type: string): ComponentRef<PaneComponent> {
    const componentToLoad = this.FacetedFilterPaneTypeMap[type];
    if (!componentToLoad) {
      throw new Error(`Component type '${type}' not found in FacetedFilterPaneTypeMap`);
    }
    const instance = this._host.createComponent(componentToLoad);

    return instance as ComponentRef<PaneComponent>;
  }
}
